var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tabs',{attrs:{"type":"border-card"},on:{"tab-click":_vm.onTabChange}},[_c('el-tab-pane',{attrs:{"label":"下单流水"}},[_c('forwardRecords',{ref:"forwardRecords"})],1),_c('el-tab-pane',{attrs:{"label":"退货流水"}},[_c('reverseRecords',{ref:"reverseRecords"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }